import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { cn } from "@/utils/cn"

interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  /** Variant for styling context - default uses brand colors, serene uses calming teal/sage colors */
  variant?: 'default' | 'serene'
}

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, variant = 'default', ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className={cn(
      "relative h-2 w-full grow overflow-hidden rounded-full",
      variant === 'serene'
         
        ? "bg-[hsl(var(--serene-bg-tertiary)_/_0.4)]"
        : "bg-secondary"
    )}>
      <SliderPrimitive.Range className={cn(
        "absolute h-full",
        variant === 'serene'
           
          ? "bg-[hsl(var(--serene-accent-primary)_/_0.7)]"
          : "bg-primary"
      )} />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className={cn(
      "block size-5 rounded-full border-2 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      variant === 'serene'
         
        ? "border-[hsl(var(--serene-accent-primary)_/_0.6)] bg-[hsl(var(--serene-text-primary))]"
        : "border-primary bg-background"
    )} />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }